<template>
  <div class="view trial-config" v-if="dataReady">
    <div class="trial-header">
      <!-- <div class="trial-name">{{trial.name || $t('new_trial')}}</div> -->
      <div class="trial-info">
        <div class="title-container">
          <!-- Harcoded temp fix: baseline trials should always contain 'Baseline' str in their names for BE handling -->
          <edit-in-place v-if="trial.name.includes('Baseline') || trial.name.includes('baseline')" class="title" format="title" v-model="trial.name" style="pointer-events:none"></edit-in-place>
          <edit-in-place v-else class="title" format="title" v-model="trial.name" @input="doSave" :placeholder="'Untitled trial'"></edit-in-place>
        </div>
        <div class="desc-container">
          <edit-in-place :isMultiline="true" class="desc" v-model="trial.description" @input="doSave" :placeholder="'Add description'"></edit-in-place>
        </div>
        <div class="actions">
          <div class="auto-save-feedback" :class="{saving: saveStatus.status==='pending', error: saveStatus.status==='error' }" :title="saveStatusText">{{saveStatusText}}</div>
          <trial-action-bar :trial="trial" :expanded="true" @duplicate="onDuplicate"></trial-action-bar>
        </div> 
      </div>
      <div class="trial-meta">
        <div class="trial-meta-item date-info">
          <div class="date-icon"></div>
          <div v-if="trial.creationTimestamp">Created: {{ trial.creationTimestamp | formatDate }}</div>
          <div v-if="trial.lastRunTimestamp">Last update: {{ trial.lastRunTimestamp | formatDate }}</div>
        </div>

        <div class="trial-meta-item tokens-info">
          <div class="tokens-icon"></div>
          <div>{{$t('cost')}}: {{trial.runConfig.computeTokens}} {{$t('compute_tokens')}}</div>
        </div>

        <div class="trial-meta-item trial-status-pill" :class="[trial.status]">
          <div class="trial-status-text">
            {{ $t("status_" + trial.status) }}
          </div>
        </div>
        <!-- TODO: fix this feature -->
        <!-- <div v-if="canEdit" class="import-from-btn btn btn-rounded" @click="()=>$modal.show('import-config')">
          <div class="add-icon"></div>{{$t('import_from')}}
        </div> -->
      </div>
      
      <!-- Perfomrance setting: <input class="name-input" v-model="trial.performance"/> -->

    </div>
    <div class="config-columns">
      <!--<div class="options-list column">
        <div class="import-from-btn btn btn--primary" @click="confirmOverwrite(activeOptionType).then(()=>$modal.show('import-config',{optionType: activeOptionType}))">{{$t('import_from')}}</div>
        <template v-if="activeOptionType === 'parameters'">
          <text-input-component class="num-subjects-field" :label="$t('number_of_subjects')" 
            v-model="trial.cohortGeneration.numberOfSubjects" 
            unit="subjects"
            :min="1"
            :max="1000"
          />
          <parameters-config v-model="trial.cohortGeneration.population.parameters"></parameters-config>
        </template>
        <template v-else>
          <trial-option-card
            v-for="(opt, optIndex) in activeOptionsList"
            :key="'option-' + opt.id + '-' + optIndex"
            :optionType="activeOptionType"
            :hasValues="hasLiveValues(activeOptionType,opt.id)"
            :option="opt"
            @addOption="addOption"
            @configureOption="openParamConfig"
            @removeOption="confirmRemove"
          ></trial-option-card>
        </template>
      </div>-->
      <div class="current-config">
        <div
          class="recap-block column"
          v-for="recapType in dynamicOptionsTypes"
          :key="'recap-' + recapType"
        >
          <div class="recap-option-name">
            {{ $t(recapType) }}
          </div>
          <div class="recap-options-container">
              <trial-option-recap
              ref="recap"
              :optionType="recapType"
              :values="getRecapValues(recapType)"
              :isEditable="canEdit"
              :isSaving="isSaving"
              @edit="onRecapEdit"
              @remove="onRecapRemove"
            />
            <v-popover v-if="canEdit && recapType != 'parameters' && domReady" class="add-config-popover" placement="right" :boundariesElement="$el" ref="optionPopovers" :disabled="isSaving">
              <div class="add-config-item" :class="{saving: isSaving}">
                <div class="add-icon"></div>
                Add {{recapType}}
                <!--<div class="user-notification"></div>-->
              </div>
              <template slot="popover">
                <div class="option-popover" >
                  <trial-option-card
                    v-for="(opt, optIndex) in optionsLists[recapType]"
                    :key="'option-' + opt.id + '-' + optIndex"
                    :optionType="recapType"
                    :hasValues="hasLiveValues(recapType,opt.id)"
                    :option="opt"
                    v-show="!hasLiveValues(recapType,opt.id)"
                    :isEditable="canEdit"
                    @addOption="addOption"
                    @configureOption="openParamConfig"
                    @removeOption="confirmRemove"
                  ></trial-option-card>
                  <div v-if="noMoreConfigAvailable(recapType)">No other {{recapType}} available</div>
                </div>
              </template>
            </v-popover>
          </div>
        </div>
      </div>
    </div>
    <modal-run-trial name="run-trial" @run="runTrial" :trial="trial"></modal-run-trial>
    <modal-option-config name="param-config" width="75%" height="60%" @save="onParamSave"></modal-option-config>
    <modal-option-config name="param-config-bull"  width="80%" height="80%" @save="onParamSave"></modal-option-config>
    <modal-option-config name="param-config-custom-drug"  width="50%" height="60%" @save="onParamSave"></modal-option-config>
    <modal-import-config name="import-config" @done="importConfig"></modal-import-config>
    <modal-create-new name="duplicate-trial-modal" type="trial_duplicate"></modal-create-new>
    <v-dialog />
  </div>
  <div class="view error" v-else-if="error">
    {{error}}
  </div>
  <div class="view" v-else>
    <loading-overlay></loading-overlay>
  </div>
</template>

<script>
import Api from '@/api'
import { getValueTypeKey, getOption, setOption, formatRanges} from '@/utils/ConfigUtils'
import TrialActionBar from '@/components/trial/TrialActionBar'
import TrialOptionCard from '@/components/trial/TrialOptionCard'
import TrialOptionRecap from '@/components/trial/TrialOptionRecap'
import ModalOptionConfig from '@/components/modals/ModalOptionConfig'
import ModalImportConfig from '@/components/modals/ModalImportConfig'
import ModalRunTrial from '@/components/modals/ModalRunTrial'
import ParametersConfig from '@/components/ParametersConfig'
import TextInputComponent from '@/components/TextInputComponent'
import LoadingOverlay from '@/components/commons/LoadingOverlay'
import trialConfig from '@/mixins/trialConfig'
import EditInPlace from '@/components/commons/EditInPlace'
import ModalCreateNew from '@/components/modals/ModalCreateNew'
import rangeParser from 'parse-numeric-range'
import { debounce } from "debounce";

export default {
  name: 'TrialConfigView',
  components: {
    TrialActionBar,
    TrialOptionCard, 
    TrialOptionRecap, 
    ModalOptionConfig,
    ModalImportConfig, 
    ModalRunTrial, 
    LoadingOverlay, 
    ParametersConfig,
    TextInputComponent,
    EditInPlace,
    ModalCreateNew
  },
  mixins: [trialConfig],
  data () {
    return {
      trial: null,
      domReady: false, // trick for popover
      // loadedValues: true,
      saveStatus: {status: ''},
      activeOptionIndex: 0,
      // dynamicOptionsTypes: ['parameters', 'diseases', 'treatments'], //ya lo pone el mixin
      // mergedValues: {}
    }
  },
  mounted () {
    this.domReady = true
  },
  computed: {
    error () {
      return this.$store.state.paramsData.error
    },
    activeOptionType () {
      return this.dynamicOptionsTypes[this.activeOptionIndex]
    },
    projectId() {
      return this.$route.params.project
    },
    trialId() {
      return this.$route.params.trial
    },
    activeOptionsList() {
      return this.optionsLists[this.activeOptionType]
    },
    dataReady () {
      return this.optionsLoaded && this.trial
    },
    activeRecapTypes () {
      let res = this.dynamicOptionsTypes.filter((type)=>{
        return this.hasLiveValues(type)
      })
      return res
    },
    saveStatusText () {
      if(this.saveStatus.status==='saved') return this.$t('saved')
      if(this.saveStatus.status==='pending' || this.saveStatus==='saving') return this.$t('saving')
      else return this.saveStatus.message
    },
    canEdit () {
      return this.trial.status == "draft"
    },
    isSaving () {
      return this.saveStatus.status==='pending' || this.saveStatus==='saving'
    }
  },
  methods: {
    noMoreConfigAvailable(optionType){
      return this.optionsLists[optionType].filter(el => !this.hasLiveValues(optionType, el.id)).length == 0
    },
    getRecapValues(optionType){
      let base = [...getOption(this.trial,optionType)]
      if(optionType==='parameters'){
        base.unshift(
          {
            id: "templateIds",
            value: [this.trial.cohortGeneration.originTemplateIds ? formatRanges(this.trial.cohortGeneration.originTemplateIds).join(', '): ''],
            valueType:'string',
            view:{
              name:'Subject template ids',
              description:  'Comma-separated ids or range like <i>1-10,20-30</i>.<br/><b>Note</b>: Using this field might affect the "Number of subjects".',
              inputType:'field',
              validate_max: ''
            }
          }
        )
        base.unshift(
          {
            id: "numSubj",
            value: [this.trial.cohortGeneration.numberOfSubjects ? this.trial.cohortGeneration.numberOfSubjects : this.trial.cohortGeneration.originTemplateIds.length],
            valueType:'integer',
            view:{
              name:this.$t('number_of_subjects'),
              inputType:'slider',
              validate_max: [100]
            }
          }
        )
        base.splice(1,1) // TODO: temp fix to hide templateIds
      }
      return base
    },
    importConfig({optArray, text}){
      // console.log("should replace",optionType,"from",src)
      if(text) {
        let d = this.trial.description || ''
        if(d.length > 0 && !['.','!','?'].includes(d.charAt(d.length-1))){
          d += '. '
        }
        d += text
        this.trial.description = d
      }
      Object.keys(optArray).forEach(optType => {
        if (optType == 'originTemplateIds') {
          this.trial.cohortGeneration.originTemplateIds = optArray[optType]
          this.trial.cohortGeneration.numberOfSubjects = optArray[optType].length
        }else {
          setOption(this.trial,optType,optArray[optType])
        }
      })
    },
    openParamConfig (paramConfig) {
      // let optArray = this.trial.cohortGeneration.population[paramConfig.optionType]
      let values, modalName
      if(paramConfig.optionType=='parameters') {
        modalName = 'param-config'
        values = JSON.parse(JSON.stringify(paramConfig.option))
      }else{
        let optArray = getOption(this.trial,paramConfig.optionType)
        let currentValue = optArray && optArray.find((d)=>d.id === paramConfig.option.id)
        if(currentValue) {
          values = JSON.parse(JSON.stringify(currentValue))
        } else {
          let config = this.optionsLists[paramConfig.optionType].find((d)=>d.id === paramConfig.option.id)
          values = JSON.parse(JSON.stringify(config))
        }
        if (this.hasBullsEye(values)) modalName = 'param-config-bull'
        else if (this.hasIonChannels(values)) modalName = 'param-config-custom-drug'
        else modalName = 'param-config'
      }

      this.$modal.show(modalName, {
        paramConfig: paramConfig,
        values: values
      })
    },
    hasBullsEye (config) {
      let fields = config.fields || [config]
      let res = fields.filter(f => f.view.inputType==="bullseye").map((d)=>d.value).flat() 
      return res.length > 0
    },
    hasIonChannels (config) {
      return config.name == "Custom Drug"
    },
    addOption (paramConfig) {
      this.$refs.optionPopovers.forEach(el => el.hide())
      let idx
      if (paramConfig.optionType==='treatments') idx = 1
      let colorScale = this.$refs.recap[idx].nextColorScale()
      this.openParamConfig({...paramConfig,colorScale})
    },
    removeParam (paramConfig){
      let optArray = getOption(this.trial,paramConfig.optionType)
      let newValue = optArray.filter((d)=>d.id!==paramConfig.option.id)
      setOption(this.trial,paramConfig.optionType,newValue)
      // this.trial.cohortGeneration.population[paramConfig.optionType] = this.trial.cohortGeneration.population[paramConfig.optionType].filter((d)=>d.id!==paramConfig.option.id)
    },
    onParamSave({paramConfig,value}){
      let optArray = []
      if(value.name == "Custom Drug") value.fields[3].value.sort((a,b) => a.id - b.id) //fix to maintain dose template id order. TODO: add dynamic input type to templates
      if(paramConfig.optionType == "parameters"){

        let templateIdsIndex = value.fields.findIndex(e => e.id == "templateIds")
        
        if (templateIdsIndex >= 0) {
          let arrTemplateIds = value.fields[templateIdsIndex].value[0] ? rangeParser(value.fields[templateIdsIndex].value[0]) : [];
          this.trial.cohortGeneration.originTemplateIds = arrTemplateIds
          value.fields.splice(templateIdsIndex, 1)
        }

        let numSubjIndex = value.fields.findIndex(e => e.id == "numSubj")

        if(this.trial.cohortGeneration.originTemplateIds.length != value.fields[numSubjIndex].value[0] && this.trial.cohortGeneration.originTemplateIds.length > 0) {
          this.$modal.show('dialog', {
          title: 'Number of subjects',
            text:`As specifified by the subject template Ids, the number of subjects in the trial will be ${this.trial.cohortGeneration.originTemplateIds.length} `,
            buttons: [
              {
                title: 'OK',
                handler: () => {
                  this.$modal.hide('dialog')
                }
              }
            ]
          })
        }

        let numSubject = this.trial.cohortGeneration.originTemplateIds.length > 0 ? this.trial.cohortGeneration.originTemplateIds.length : value.fields[numSubjIndex].value[0]
        this.trial.cohortGeneration.numberOfSubjects = numSubject
        value.fields.splice(numSubjIndex, 1)

        optArray = value.fields
      } else {
        // let popArray = this.trial.cohortGeneration.population[paramConfig.optionType] || []
        optArray = getOption(this.trial,paramConfig.optionType) || []
        // this.trial.cohortGeneration.population[paramConfig.optionType] = popArray
        let candidate = optArray.find((d)=>d.id===paramConfig.option.id)
        if(candidate) optArray.splice(optArray.indexOf(candidate),1)
        optArray.push(value)
      }
      setOption(this.trial, paramConfig.optionType, optArray)
    },
    confirmOverwrite(optionType){
      return new Promise((res,rej)=>{
        if(getOption(this.trial,optionType).length>0){
          this.$modal.show('dialog', {
            title: 'Warning',
            text:`You are going to import ${this.$t(optionType)} from another trial. All existing ${this.$t(optionType)} configurations will be lost!`,
            buttons: [
              {
                title: 'Cancel',
                handler: () => {
                  rej()
                  this.$modal.hide('dialog')
                }
              },
              {
                title: 'Understood',
                handler: () => {
                  res()
                  this.$modal.hide('dialog')
                }
              }
            ]
          })
        } else {
          res()
        }
      })
    },
    confirmRemove(paramConfig){
      this.$modal.show('dialog', {
        title: 'Remove configuration',
        text:`Are you sure you want to delete ${paramConfig.option.name}?`,
        buttons: [
          {
            title: 'Cancel',
            handler: () => this.$modal.hide('dialog')
          },
          {
            title: 'Yes',
            handler: () => {
              this.removeParam(paramConfig)
              this.$modal.hide('dialog')
            }
          }
        ]
      })
    },
    // fillWithTemplateData(data){
    //   data = JSON.parse(JSON.stringify(data))
    //   // return this.mergeViewIntoValues
    //   console.log("optionsLsits",this.optionsLists)
    //   this.dynamicOptionsTypes.map((optionType)=>{
    //     // (data.cohortGeneration.population[optionType] || []).forEach((value)=>{
    //     (getOption(data,optionType) || []).forEach((value)=>{
    //       let template = this.optionsLists[optionType].find((d)=>d.id === value.id)
    //       if(template) this.mergeViewIntoValues(value,template)
    //       else console.warn(`WTF!: template not found for ${optionType} - ${value.id}`)
    //     })
    //   })
    //   return data
    // },
    setUnsaved () {
      this.saveStatus = {status:'pending'}
      this.queueSave()
    },
    onDuplicate(){
      this.$modal.show('duplicate-trial-modal',{trial: this.trial})
    },
    
    // HAY QUE "hacer el cancel" ANTES del queue, pero ¿como generamos el reqId antes de hacer el "actualReq" ????
    queueSave () {
      // console.log("shoud CANCEL but not PUT yet")
      Api.cancelPutTrial(this.trial)
      this.debouncedDoSave()
    },
    debouncedDoSave: debounce(function(){this.doSave()},1200),
    doSave () {
      console.log(`PUT {trial: ${this.trial.id}}`)
      Api.putTrial(this.trial).then(()=>{
        this.saveStatus = {status:'saved'}
      }).catch((err) => {
        if(err){
          console.error(err)
          let msg = 'Could not save: ' + JSON.stringify(err.response.data.detail)
          this.saveStatus = {status:'error', message: msg}
        }
      })
    },
    onRecapEdit (paramConfig) {
      this.activeOptionIndex = this.dynamicOptionsTypes.findIndex((o)=>o === paramConfig.optionType)
      this.openParamConfig(paramConfig)
    },
    onRecapRemove (paramConfig) {
      this.confirmRemove(paramConfig)
    },
    onRunClicked(){
      this.$modal.show('run-trial')
    },
    runTrial(){
      Api.setTrialStatus(this.trial,'ready').then(()=>{
        console.log("trial status udpated!!")
      })
    },
    loadTrialFromStore(){
      if(!this.optionsLoaded || !this.$store.state.paramsData.trial) return
      if(this.unwatchTrial) this.unwatchTrial()
      this.trial = this.fillWithTemplateData(this.$store.state.paramsData.trial)
      this.$nextTick(()=>{
        this.unwatchTrial = this.$watch('trial',this.setUnsaved,{deep:true})
      })
    }
  },
  created () {
    this.loadTrialFromStore()
  },
  watch: {
    '$store.state.paramsData.trial' (newValue) {
      // console.log("newValue",newValue)
      this.loadTrialFromStore()
    },
    optionsLoaded () {
      this.loadTrialFromStore()
    },
    trialId () {
      this.$modal.hideAll()
      this.$modal.hide('duplicate-trial-modal')
      this.loadTrialFromStore()
    }
  }
}
</script>

<style lang="stylus" scoped>
.trial-config
  display: flex
  flex-direction: column

  .trial-header
    background $titan-white
    padding-top: 15px
    padding-bottom: 15px
    padding-left: 80px
    padding-right: 80px
    .trial-info
      border-bottom 1px solid $mystic
      margin-bottom 20px
      padding-bottom 20px
      position relative

      .actions
        display: flex
        position absolute
        right 0px
        top 0px
        align-items center
        .auto-save-feedback
          color $spun-pearl
          margin-right 20px
          &.saving
            color $cloud-burst
          &.error
            color $radical-red
            opacity 0.6
            max-width: 350px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: pre;
    .trial-meta
      m-font-size(14,18)
      color $river-bed
      display flex
      align-items center
      .trial-meta-item
        display flex
        align-items center
        margin-right 24px
      .date-icon
        m-icon("calendar", 28)
      .tokens-icon
        m-icon("tokens", 18)
        margin-right 5px

  .config-columns
    display: flex
    overflow: hidden
    max-height 100%
    flex 1 1 auto
    background-image: url("~@/assets/background_image.png")
    background-repeat: no-repeat
    background-size: cover

    .tab-list
      border-right: 1px solid #fff
      color: $cloud-burst
      flex: 0 0 20%
      padding: 40px 0 40px 50px

      .options-tab
        cursor: pointer
        m-font-size(14, 18)
        opacity: 0.5
        padding: 5px 0
        padding-right: 40px

        &:not(:last-child)
          margin-bottom: 5px

        &:hover
          opacity: 1

        &.active
          border-right: 4px solid $radical-red
          cursor: default
          font-weight: $fw-semi-bold
          opacity: 1

    .options-list
      border-right: 1px solid #fff
      display: flex
      flex: 0 0 40%
      flex-direction: column
      flex-wrap: nowrap
      overflow-y: auto
      padding: 40px

    .current-config
      display: flex
      flex-direction: row
      width: 100%
      justify-content: space-between
      padding-top 20px
      .column
        height: 100%
        //overflow: hidden
        flex 0 0 50%
        padding-bottom 0px

      .recap-block
        &:not(:last-child)
          margin-bottom: 20px

      .recap-option-name
        m-font-size(18, 30)
        margin-right 30px
        margin-left 30px
        font-weight: $fw-bold
        margin-bottom: 10px
        padding-bottom: 10px
        border-bottom 1px solid $titan-white
        display flex
        width calc(100% - 60px)
        align-items center
      
      .recap-options-container
        max-height calc(100% - 45px)
        min-height calc(100% - 45px)
        overflow auto
        padding-right 30px
        padding-left 30px

      .add-config-item
        color $cloud-burst
        m-font-size(14,18)
        background-color: rgba($titan-white, 0.2)
        display flex
        align-items center
        justify-content center
        height 50px
        border 1px dashed $titan-white
        border-radius 4px
        width 100%
        cursor pointer
        margin-bottom 20px
        &.saving
          opacity 0.5
        &:hover
          background-color: rgba($titan-white, 0.4)
        .add-icon
          m-icon("add-red", 25)
          margin-right 8px
</style>

<style lang="stylus">
.options-list
  //special fields
  .num-subjects-field
    padding: 0 0px 20px 0px;
    width 100%
    border-bottom 1px solid $heather
    margin-bottom 20px
    .input-wrapper
      max-width: 140px;
  .sub-fields-container
    border-bottom 1px solid $heather
    padding-bottom 20px
    .input-component
      padding 0px
.add-config-popover
  &:hover
     .add-config-item
        background-color: rgba($titan-white, 0.4)
  .trigger
    width 100%

.import-from-btn
  margin-left auto
  .add-icon
    m-icon("add-red", 22)
    margin-right 6px
.option-popover
  width 400px
  max-height 400px
  background $titan-white
  overflow auto
  padding 15px

.input-component
  #templateIds.text-input
      width 100%
      input
        width 100%
        margin-right 20px
</style>